require('./bootstrap')


// fixes https://github.com/JeffreyWay/laravel-mix/issues/2064#issuecomment-532698484
require('../sass/fake.scss');

import { InertiaApp, plugin } from '@inertiajs/inertia-vue'
import Vue from 'vue'

Vue.use(plugin)


import { InertiaProgress } from '@inertiajs/progress'

InertiaProgress.init({
  color: '#70bf41',
})

// TODO: the routes should only be available after login.
// Or: we need to find a way to have two different implementations:
// one for auth and one for logged-in
import { route as ziggyRoute } from 'ziggy';
import { Ziggy } from './ziggy';
const ziggyConfig = Ziggy.routes
  ? Ziggy
  : {
      routes: Ziggy.namedRoutes || {},
      url: (Ziggy.baseUrl || '').replace(/\/$/, ''),
      port: Ziggy.basePort || null,
      defaults: Ziggy.defaultParameters || {},
    };
// Vue.prototype.$route = (...args) => route(...args)
Vue.mixin({
  methods: {
      route: (name, params, absolute) =>
        ziggyRoute(name, params, absolute, ziggyConfig),
  },
});


// TODO: create a custom tooltip directive or maybe find a better one
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

Vue.use(Tooltip, {
  placement: 'body',
  class: 'tooltip-custom',
});




import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})



// import { Datepicker } from '@livelybone/vue-datepicker';

// Vue.component('datepicker', Datepicker);



// import { Datepicker } from '@livelybone/vue-datepicker';
// Vue.component('datepicker', Datepicker);


import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// import Multiselect from 'vue-multiselect';
// // Vue.use(Multiselect)
// Vue.component('multiselect', Multiselect)


// import VueCarousel from 'vue-carousel';
// Vue.use(VueCarousel);


// import { VueMasonryPlugin } from 'vue-masonry';
// Vue.use(VueMasonryPlugin);
// import 'masonry-layout/dist/masonry.pkgd.min.js';


// import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload)


Vue.filter('formatDate', function (date) {
  if(!date) return ''

  var d = new Date(date);
  return d.toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  // return `${d.getDate()}.${d.getFullMonth() + 1}.${d.getFullYear()}`; 
});

Vue.filter('formatTime', function (time) {
  if(!time) return ''

  var t = new Date(time);
  return t.toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit'
  });
});


Vue.filter('formatDateTime', function (date) {
  if(!date) return ''

  var d = new Date(date);
  
  return d.toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }) + ' Uhr';

  // return `${d.getDate()}.${d.getFullMonth() + 1}.${d.getFullYear()}`; 
});

Vue.filter('formatFilesize', function (filesize) {
  if (!filesize) return '';

  if (filesize >= 1000000) {
    let size = (filesize / 1000000).toFixed(1);
    return `${size} MB`;
  }

  let size = (filesize / 1000).toFixed(0);
    return `${size} KB`;
});


let app = document.getElementById('app')

new Vue({
  metaInfo: {
    titleTemplate: (title) => title ? `${title} - M&E Intranet Backend` : 'M&E Intranet Backend'
  },
  render: h => h(InertiaApp, {
    props: {
      initialPage: JSON.parse(app.dataset.page),
      resolveComponent: (name) => {
        return import(`@/Pages/${name}`).then(module => module.default)
      },
    },
  }),
}).$mount(app)
